import { render, staticRenderFns } from "./ClassRoomEducation.vue?vue&type=template&id=3b149c9d&scoped=true&xmlns=http%3A%2F%2Fwww.w3.org%2F1999%2Fhtml"
import script from "./ClassRoomEducation.vue?vue&type=script&lang=js"
export * from "./ClassRoomEducation.vue?vue&type=script&lang=js"
import style0 from "./ClassRoomEducation.vue?vue&type=style&index=0&id=3b149c9d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b149c9d",
  null
  
)

export default component.exports